import { type Appointment } from "@repo/api";
import { Status, type StatusProps } from "@repo/skapa";
import { translateAppointmentStatus } from "@repo/ui";

const statusColorMap: Record<
  Appointment["appointmentStatus"],
  StatusProps["variant"]
> = {
  PUBLISHED: "negative",
  ORDER_RECEIVED: "negative",
  ORDER_RECEIVED_WAITING_FOR_PAYMENT: "negative",
  CANCELLED: "indeterminate",
  CANCELLED_NO_SHOW: "indeterminate",
  STARTED: "cautionary",
  COMPLETED: "positive",
  PLANNED: "cautionary",
};

export const AppointmentStatusIndicator = ({
  status,
  small,
}: {
  status?: Appointment["appointmentStatus"];
  small?: boolean;
}) => {
  if (!status) {
    return null;
  }
  return (
    <Status
      small={small}
      variant={statusColorMap[status]}
      label={translateAppointmentStatus(status)}
    />
  );
};
